import { Alert, Button } from "@mui/material";
import { Link } from "react-router";
import { getAutoRecipeRecoveryContext } from "components/defaultParameters/AutoRecipeDefaultsRecovery";
import { useTenantTranslation } from "hooks/formatters";
import { useTenant } from "hooks/settings";
import { SearchType } from "store/api/generatedApi";

export const AutoRecipeDefaultsLoadError = ({
  error,
  searchType,
  refresh,
}: {
  error: unknown;
  searchType: SearchType;
  refresh: () => Promise<unknown>;
}) => {
  const { t } = useTenantTranslation();
  const tenantName = useTenant();
  const unsupported = getAutoRecipeRecoveryContext({ error, searchType });
  return (
    <Alert
      severity="error"
      action={
        unsupported ? (
          <Button
            component={Link}
            to={`/${tenantName}/parameters/search-parameters?searchType=${searchType}`}
          >
            {t("defaultParameters")}
          </Button>
        ) : (
          <Button
            onClick={() => {
              void refresh();
            }}
          >
            {t("retry")}
          </Button>
        )
      }
    >
      {t(unsupported ? "autoDefaultsUnsupported" : "errorLoadingData")}
    </Alert>
  );
};
